import axios from "../Axios";

const BASE_URL = '/settings';

export default {
    async getSettings() {
        const response = await axios.get(BASE_URL);
        return response.data.data;
    },
    async updateSettings(settings) {
        const formData = new FormData();
        formData.append('_method', 'PUT');

        if (settings.restaurant_name !== undefined && settings.restaurant_name !== null) {
            formData.append('restaurant_name', settings.restaurant_name);
        }
        if (settings.logo_image instanceof File) {
            formData.append('logo_image', settings.logo_image);
        }
        if (settings.language_selection_background_type) {
            formData.append('language_selection_background_type', settings.language_selection_background_type);
        }
        if (settings.language_selection_background_path instanceof File) {
            formData.append('language_selection_background_path', settings.language_selection_background_path);
        }
        if (settings.home_background_type) {
            formData.append('home_background_type', settings.home_background_type);
        }
        if (settings.home_background_path instanceof File) {
            formData.append('home_background_path', settings.home_background_path);
        }
        if (Array.isArray(settings.payment_methods)) {
            settings.payment_methods.forEach((method) => formData.append('payment_methods[]', method));
        }
        if (settings.card_gateway) {
            formData.append('card_gateway', settings.card_gateway);
        }
        if (settings.main_page_hero_image instanceof File) {
            formData.append('main_page_hero_image', settings.main_page_hero_image);
        }
        const heroTextFields = [
            'main_page_hero_title_en',
            'main_page_hero_title_ar',
            'main_page_hero_subtitle_en',
            'main_page_hero_subtitle_ar',
            'main_page_hero_description_en',
            'main_page_hero_description_ar',
        ];
        heroTextFields.forEach((field) => {
            if (settings[field] !== undefined && settings[field] !== null) {
                formData.append(field, settings[field]);
            }
        });

        const response = await axios.post(BASE_URL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.data;
    },
};
